module.exports = __webpack_public_path__ + "static/img/more.3fd30d06.svg";